import { DataBean } from "../../../DataBean";



export class DiagnosisHelp extends DataBean {


    public async getHealthDiagnosisHelpCatalog(year:any,month:any,idAccount:any,idClinicalDocument:any,issueDate:any,idHealthLOINC:any,idHealthAssesmentResult:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthDiagnosisHelpCatalog_Number_Number_Number_Number_java.util.Date_Number_Number_String_Number_Number", [year,month,idAccount,idClinicalDocument,issueDate,idHealthLOINC,idHealthAssesmentResult,regexStr,page,recordsPerPage]);
    }


}